import React from "react";
import { Content } from "./TextMessageDisplay.style";

export default ({ message }) => {
    return <Content className="">{message.text}</Content>;
};